import styled from "@emotion/styled";
import React from "react";
import { Spinner } from "../../spinner";
import { getButtonTextColor } from "../styled/getButtonTextColor";
export const LoadingSpinner = _ref => {
  let {
    appearance,
    themeMode
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledLoadingSpinner, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "medium",
    color: getButtonTextColor({
      appearance,
      themeMode,
      state: {
        isActive: false,
        isDisabled: false,
        isFocus: false,
        isHover: false
      }
    })
  }));
};
const StyledLoadingSpinner = styled("div")`
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;
//# sourceMappingURL=LoadingSpinner.js.map